<template>
  <common-dialog ref="dialog" :title="title" width="500px" :in-dialog="inDialog">
      <el-input type="number" v-model="ThisReworkQuantity" />
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="save" :disabled="!ThisReworkQuantity">保存</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import dialogMixins from "@/mixins/dialog";

export default {
  components: { commonDialog, },
  mixins: [dialogMixins],
  props: {
    title: {
      type: String,
      default: "数量调整",
    },
  },
  data() {
    return {
      api: require("@/api/pu/prTestRework").default,
      TestReworkDtsId: 0,
      ThisReworkQuantity: 0,
    };
  },
  
  methods: {
    save(){
      let o = {
        TestReworkDtsId: this.TestReworkDtsId,
        ThisReworkQuantity: Number(this.ThisReworkQuantity),
      }
      console.log('o', o)
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      this.api.updateRework(o).then(res => {
        loading.close()
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg})
          this.$emit('update', this.ThisReworkQuantity);
          this.close()
        }else{
          this.$message({type: 'warning', message: res.Msg})
          this.close()
        }
      }).catch(err => {
        loading.close()
      })
    }
  },
};
</script>